import { render, staticRenderFns } from "./ResolutionMedia.vue?vue&type=template&id=3487f396&"
import script from "./ResolutionMedia.vue?vue&type=script&lang=js&"
export * from "./ResolutionMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports